import React from 'react';
import { ImageIcon } from './ui/icons';

const MediaPlaceholder = ({ icon: Icon = ImageIcon, className = '' }) => {
  return (
    <div className={`relative flex h-full w-full items-center justify-center overflow-hidden bg-dark ${className}`}>
      <img
        src="/logohistorio.png"
        alt="Historio"
        className="pointer-events-none h-20 w-20 opacity-15 object-contain"
      />
      <div className="absolute inset-0 flex items-center justify-center text-bronze/75">
        <Icon className="h-12 w-12" />
      </div>
    </div>
  );
};

export default MediaPlaceholder;

